/**
 * Parse Firestore Timestamp shapes from JSON/API: { seconds }, { _seconds },
 * ISO strings, millis numbers, or client Timestamp with toDate().
 */
export function parseFirestoreTimestamp(value: unknown): Date | null {
  if (value == null) return null;
  if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
  if (typeof value === 'string' || typeof value === 'number') {
    const d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
  }
  if (typeof value === 'object') {
    const o = value as Record<string, unknown>;
    if (typeof o.toDate === 'function') {
      try {
        const d = (o as { toDate: () => Date }).toDate();
        return d instanceof Date && !isNaN(d.getTime()) ? d : null;
      } catch {
        /* ignore */
      }
    }
    const secRaw =
      typeof o.seconds === 'number'
        ? o.seconds
        : typeof o._seconds === 'number'
          ? o._seconds
          : typeof o.seconds === 'string'
            ? parseInt(o.seconds, 10)
            : typeof o._seconds === 'string'
              ? parseInt(o._seconds, 10)
              : undefined;
    if (secRaw != null && Number.isFinite(secRaw)) {
      const ns =
        typeof o.nanoseconds === 'number'
          ? o.nanoseconds
          : typeof o._nanoseconds === 'number'
            ? o._nanoseconds
            : 0;
      return new Date(secRaw * 1000 + Math.floor(ns / 1e6));
    }
  }
  return null;
}

export function formatFirestoreDate(value: unknown, empty = '—'): string {
  const d = parseFirestoreTimestamp(value);
  return d ? d.toLocaleString() : empty;
}

export function formatFirestoreDateOnly(value: unknown, empty = '—'): string {
  const d = parseFirestoreTimestamp(value);
  return d ? d.toLocaleDateString() : empty;
}
